module.exports = "/static/assets/097fb032029a18d346eb4e0662bdd41b.png";